import { cn } from "@/lib/utils";
import React from "react";
import { Scrollable } from "../Scrollable/Scrollable";
import { PAGE_DOCUMENT_MAX_WIDTH, PAGE_X_PADDING } from "./consts";

interface PageBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  rigid?: boolean;
  document?: boolean;
  children: React.ReactNode;
  outerClassName?: string;
  innerClassName?: string;
}

const MAX_SHADOW_HEIGHT = 100;

export const PageBody: React.FC<PageBodyProps> & {
  Metadata: React.FC<MetadataProps>;
  MetadataGroup: React.FC<MetadataProps>;
} = ({
  children,
  rigid = false,
  document = false,
  outerClassName,
  innerClassName,
  ...props
}) => {
  if (rigid) {
    return (
      <div
        data-slot="page-body-outer"
        className={cn(
          "flex w-full flex-col items-center py-4",
          PAGE_X_PADDING,
          outerClassName,
        )}
        {...props}
      >
        <div
          data-slot="page-body-inner"
          className={cn(
            "flex w-full flex-1 flex-col gap-4",
            {
              [PAGE_DOCUMENT_MAX_WIDTH]: document,
            },
            innerClassName,
          )}
        >
          {children}
        </div>
      </div>
    );
  }

  return (
    <Scrollable
      data-slot="page-body-outer"
      outerClassName={cn("flex flex-col flex-1 w-full", outerClassName)}
      innerClassName={cn("flex flex-col flex-1 items-center", PAGE_X_PADDING)}
      fromColorClassName={document ? "from-background" : "from-background-1"}
      maxShadowHeight={MAX_SHADOW_HEIGHT}
    >
      <div
        data-slot="page-body-inner"
        className={cn(
          "flex w-full flex-1 flex-col gap-4 py-4",
          {
            [PAGE_DOCUMENT_MAX_WIDTH]: document,
          },
          innerClassName,
        )}
      >
        {children}
      </div>
    </Scrollable>
  );
};

type MetadataProps = React.PropsWithChildren<{ className?: string }>;

const Metadata: React.FC<MetadataProps> = ({ children, className }) => {
  return (
    <div
      className={cn(
        "border-border mb-4 flex flex-row items-center gap-4 border-b pb-4 text-sm text-gray-500",
        className,
      )}
    >
      {children}
    </div>
  );
};

const MetadataGroup: React.FC<MetadataProps> = ({ children, className }) => {
  return (
    <div className={cn("flex flex-row items-center gap-4", className)}>
      {children}
    </div>
  );
};

PageBody.Metadata = Metadata;
PageBody.MetadataGroup = MetadataGroup;
